import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API_CONFIG } from "src/config/api.config";
import { Venda } from "../classes/productvenda";
import { AuthService } from "./auth.service";
import { CondicaoLists } from "../classes/condicao-list";

@Injectable({
    providedIn: 'root'
})

export class LinkPagamentoService {
    apriUrl = `${API_CONFIG.baseUrl}/venda`;
    apriUrlCondicao = `${API_CONFIG.baseUrl}/condicao`;
    postId;
    putId;


    constructor(
        private httpClient: HttpClient,
        private storage: AuthService
    ) { }

    public postVendaLink(venda: any, tipo: any, parcelas: number): Observable<Venda> {
        // return null;
        return this.httpClient.post(this.apriUrl + '/linkpagamento?qtdParcelas='
            + parcelas + '&tipoRec=' + tipo, venda);
    }

    public getVendaByIdU(ident: any): Observable<Venda> {
        return this.httpClient.get<Venda>(this.apriUrl + '/' + ident);
    }

    public getVendaById(ident: any): Observable<Venda[]> {
        return this.httpClient.get<Venda[]>(this.apriUrl + '/' + ident);
    }

    public getEmailComprovante(idVenda: any, email: any): Observable<any> {
        return this.httpClient.get<any>(this.apriUrl + '/comprovanteenviar/' + idVenda + '?email=' + email);
    }

    public getCondicao(): Observable<CondicaoLists[]> {
        return this.httpClient.get<CondicaoLists[]>(this.apriUrlCondicao);
    }
}